var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorstSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 0.00671387,
    y: 0.843384,
    width: 46.8138,
    height: 46.8138,
    rx: 23.4069,
    fill: "#FF5F44"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8775_63272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.7362 23.9717C33.7362 26.5271 32.721 28.9778 30.9141 30.7847C29.1072 32.5916 26.6565 33.6068 24.1011 33.6068C21.5457 33.6068 19.095 32.5916 17.2881 30.7847C15.4812 28.9778 14.4661 26.5271 14.4661 23.9717C14.4661 21.4163 15.4812 18.9656 17.2881 17.1587C19.095 15.3518 21.5457 14.3367 24.1011 14.3367C26.6565 14.3367 29.1072 15.3518 30.9141 17.1587C32.721 18.9656 33.7362 21.4163 33.7362 23.9717ZM24.1011 19.1542C23.9489 19.1543 23.7984 19.1863 23.6592 19.248C23.5201 19.3098 23.3955 19.4001 23.2934 19.513C23.1913 19.6259 23.1139 19.7589 23.0664 19.9035C23.0188 20.0481 23.002 20.2011 23.0172 20.3526L23.4387 24.5763C23.4529 24.7422 23.5288 24.8968 23.6514 25.0095C23.7741 25.1221 23.9346 25.1846 24.1011 25.1846C24.2676 25.1846 24.4281 25.1221 24.5508 25.0095C24.6734 24.8968 24.7494 24.7422 24.7635 24.5763L25.1851 20.3526C25.2002 20.2011 25.1834 20.0481 25.1359 19.9035C25.0883 19.7589 25.011 19.6259 24.9088 19.513C24.8067 19.4001 24.6821 19.3098 24.543 19.248C24.4039 19.1863 24.2533 19.1543 24.1011 19.1542ZM24.1035 26.3805C23.7841 26.3805 23.4778 26.5074 23.2519 26.7332C23.026 26.9591 22.8991 27.2654 22.8991 27.5849C22.8991 27.9043 23.026 28.2106 23.2519 28.4365C23.4778 28.6623 23.7841 28.7892 24.1035 28.7892C24.4229 28.7892 24.7293 28.6623 24.9551 28.4365C25.181 28.2106 25.3079 27.9043 25.3079 27.5849C25.3079 27.2654 25.181 26.9591 24.9551 26.7332C24.7293 26.5074 24.4229 26.3805 24.1035 26.3805Z",
    fill: "#FF5F44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8775_63272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2701,
    height: 19.2701,
    fill: "white",
    transform: "translate(14.4661 14.3363)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorstSubject);
export default __webpack_public_path__ + "static/media/WorstSubject.9a5623384d13f929307ee08007d9af74.svg";
export { ForwardRef as ReactComponent };